export default __webpack_public_path__ + "search-examples-category-based-search-thumbnail-480-8d0584304e809c08e282e30a8c9cee7e.png";